<template>
    <v-row no-gutters class="eventRaceImages">
      <v-col class="pa-3">
        <RaceImage />
      </v-col>
    </v-row>
</template>

<script>
import RaceImage from "@/components/dashboard/eventDetails/raceList/RaceImage.vue";

export default {
    components: {
        RaceImage
    }    
}
</script>

<style lang="scss" scoped>
    
</style>